<template>
  <div  style="background-color: white">
    <div class="content"   >
      <div  style="margin-bottom:2.4rem;margin-top: 0.6rem ">
      <div class="labeldiv" style="margin-left:2rem;font-weight: bold " >联系我们</div>
      </div>
      <hr />
      <div style="margin-bottom: 3rem;margin-top:2rem;margin-left:2rem;margin-right: 2rem">
        <div style="margin-bottom: 1rem;color: #00469A;">
             吉凯基因淘基因致力于与您共享吉凯" 工程化科研平台 " 15年来积累的科研资源，为您提供优质的产品和服务
        </div>
        <div style="margin-bottom: 1rem;color: #00469A;">
          如果您有任何建议或意见，可以通过以下方式联系我们：
        </div>
        <div>
          电话：<a href="tel:400-621-0302">400-621-0302</a>
        </div>
<!--        <div>-->
<!--          固话咨询：800-720-0302-->
<!--        </div>-->
        <div>
          Email：service@genechem.com.cn
        </div>
        <div>
          联系地址：上海市浦东新区爱迪生路332号
        </div>
       </div>
    </div>
  </div>
</template>
<script>
  export default {
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content {
    background-color: white
  }
  hr {
    height:0.08rem;
    border:0.08rem;
    background-color:#00469A;
  }
  .labeldiv {
    margin-left: 0.2rem;
    margin-bottom: 0rem;
    color: #00469A;
    font-size: 1.2rem;
    float: left
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?46d7a3fe